import DashboardIcon from "@mui/icons-material/Dashboard";
import CategoryIcon from "@mui/icons-material/Category";
import LogoutIcon from "@mui/icons-material/Logout";
import RestaurantIcon from "@mui/icons-material/Restaurant";
import FoodBankIcon from "@mui/icons-material/FoodBank";
import { useContext } from "react";
import MenuIcon from "@mui/icons-material/Menu";
import { AdminDataContext } from "../../../useContext/AdminContext";
import PersonIcon from "@mui/icons-material/Person";
import DiscountIcon from "@mui/icons-material/Discount";
import Person4Icon from "@mui/icons-material/Person4";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import DeliveryDiningIcon from "@mui/icons-material/DeliveryDining";
import ViewCarouselIcon from "@mui/icons-material/ViewCarousel";
import NotificationsIcon from "@mui/icons-material/Notifications";
import StoreIcon from "@mui/icons-material/Store";
import ManageHistoryIcon from "@mui/icons-material/ManageHistory";
import ProductionQuantityLimitsIcon from "@mui/icons-material/ProductionQuantityLimits";
import LockResetIcon from "@mui/icons-material/LockReset";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import GroupIcon from "@mui/icons-material/Group";
import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";
import WebhookIcon from "@mui/icons-material/Webhook";
const useContent = () => {
  const { adminData } = useContext(AdminDataContext);
  console.log("adminData", adminData);
  // const updatedNeedToRemove = { ...adminData, permissions: "SUPER_ADMI" };
  const content = [
    // {
    //   icon: DashboardIcon,
    //   text: "Dashboard",
    //   slug: "",
    // },
    {
      icon: ProductionQuantityLimitsIcon,
      text: "Bundle Management",
      slug: "",
    },
    {
      icon: FormatListBulletedIcon,
      text: "BC Products",
      slug: "bc-products",
    },

    {
      icon: LockResetIcon,
      text: "Change Password",
      slug: "change-password",
    },

    {
      icon: WebhookIcon,
      text: "Manage Webhooks",
      slug: "manage-webhooks",
    },
  ];
  if (adminData.userType === "SUPER_ADMIN") {
    content.push({
      icon: PersonAddIcon,
      text: "Add User",
      slug: "add-user",
    });
  }
  if (adminData.userType === "SUPER_ADMIN") {
    content.push({
      icon: GroupIcon,
      text: "User List",
      slug: "user-list",
    });
  }
  // if (adminData.permissions.restaurant) {
  //   content.push({
  //     icon: RestaurantIcon,
  //     text: "Manage Restaurants",
  //     slug: "restaurant",
  //     items: [
  //       {
  //         text: "Onboarding",
  //         slug: "onboarding",
  //       },
  //       // {
  //       //   text: "Add Menu Item",
  //       //   slug: "select-restaurant",
  //       // },

  //       {
  //         text: "Pet Pooja",
  //         slug: "pet_pooja",
  //       },
  //       {
  //         text: "UnVerified Pet Pooja",
  //         slug: "unverified_pet_pooja",
  //       },
  //       {
  //         text: "Verified",
  //         slug: "verified",
  //       },
  //       {
  //         text: "App Visibility",
  //         slug: "app_visibility",
  //       },
  //       {
  //         text: "Active Restaurant",
  //         slug: "active-restaurant",
  //       },
  //       {
  //         text: "Unverified",
  //         slug: "unverified",
  //       },
  //       {
  //         text: "Bhiwandi Restaurant",
  //         slug: "bhiwandi-restaurant",
  //       },
  //       {
  //         text: "Owner",
  //         slug: "owner",
  //       },
  //       {
  //         text: "AppReview Restaurant",
  //         slug: "appReview",
  //       },
  //       {
  //         text: "Online",
  //         slug: "online",
  //       },
  //     ],
  //     // restaurant/online
  //   });
  // }

  // if (adminData.permissions.restaurant) {
  //   content.push({
  //     icon: RestaurantIcon,
  //     text: "Menu Items",
  //     slug: "i",
  //     items: [
  //       {
  //         text: "Categories",
  //         slug: "categories",
  //       },
  //       {
  //         text: "Variants",
  //         slug: "variants",
  //       },
  //       {
  //         text: "Addons",
  //         slug: "addons",
  //       },
  //       {
  //         text: "Items",
  //         slug: "items",
  //       },
  //     ],
  //     // restaurant/online
  //   });
  // }

  // if (adminData.permissions.restaurant) {
  //   content.push({
  //     icon: RestaurantIcon,
  //     text: "Manage Order",
  //     slug: "order",
  //     items: [
  //       {
  //         text: "Assign Order",
  //         slug: "deliveryBoyNotAvailable",
  //       },
  //       {
  //         text: "All Orders",
  //         slug: "allOrders",
  //       },

  //       {
  //         text: "Discounted Orders",
  //         slug: "discountedOrders",
  //       },
  //       {
  //         text: "Restaurant not accepted",
  //         slug: "restaurantNotAccepted",
  //       },
  //       {
  //         text: "Delivery Boy availability",
  //         slug: "delivery-boy-availability",
  //       },
  //     ],
  //   });
  // }

  // // festive categories

  // if (adminData.permissions.category) {
  //   content.push({
  //     icon: DeliveryDiningIcon,
  //     text: "Category",
  //     slug: "category",
  //     items: [
  //       {
  //         text: "Category",
  //         slug: "",
  //       },
  //       {
  //         text: "Festive Category",
  //         slug: "festive-category",
  //       },
  //     ],
  //   });
  // }

  // if (adminData.permissions.category) {
  //   content.push({
  //     icon: StoreIcon,
  //     text: "Brand",
  //     slug: "brand",
  //   });
  // }

  // if (adminData.permissions.complain) {
  //   content.push({
  //     icon: HelpOutlineIcon,
  //     text: "Ticket",
  //     slug: "ticket",
  //     items: [
  //       {
  //         text: "Restaurant Ticket",
  //         slug: "ticket/r",
  //       },
  //       {
  //         text: "Delivery Ticket",
  //         slug: "ticket/d",
  //       },
  //     ],
  //   });
  // }

  content.push({
    icon: LogoutIcon,
    text: "Logout",
    slug: "logout",
  });
  return content;
};
export default useContent;
